import { ErrorHandler, Injectable } from '@angular/core';
import { AuthRedirectService } from '../auth/auth-redirect.service';
import { ClientErrorReporter } from '../shared/services/error/client-error-reporter.service';

/**
 * Global Angular ErrorHandler — catches Auth0 session-expiry errors that
 * surface as unhandled RxJS errors (i.e. thrown to a subscriber with no
 * error callback) and redirects to login.  Acts as a safety net in addition
 * to the authErrorInterceptor. Every other uncaught error is logged to the
 * console and sent to the backend log (ClientErrorReporter).
 */
@Injectable()
export class AuthErrorHandler implements ErrorHandler {
  // NOTE: ErrorHandler is instantiated outside Angular's injection context,
  // so inject() does not work here — constructor injection is required.
  /* eslint-disable @angular-eslint/prefer-inject */
  constructor(
    private readonly authRedirect: AuthRedirectService,
    private readonly clientErrorReporter: ClientErrorReporter,
  ) {}
  /* eslint-enable @angular-eslint/prefer-inject */

  handleError(error: unknown): void {
    if (this.authRedirect.isAuthError(error)) {
      this.authRedirect.redirectToLogin();
      return;
    }
    console.error(error);
    this.clientErrorReporter.send(error, { source: 'ErrorHandler' });
  }
}
